import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import children from './../../../../../assets/images/svg/002-children.svg';
import noChildren from './../../../../../assets/images/svg/002-nochildren.svg';

import celibataireW from './../../../../../assets/images/svg/001-W-celibataire.svg';
import unionsW from './../../../../../assets/images/svg/001-W-unions.svg';
import divorceeW from './../../../../../assets/images/svg/001-W-divorcee.svg';
import veuveW from './../../../../../assets/images/svg/001-W-veuve.svg';

import celibataireM from './../../../../../assets/images/svg/001-M-celibataire.svg';
import unionsM from './../../../../../assets/images/svg/001-M-unions.svg';
import divorceeM from './../../../../../assets/images/svg/001-M-divorcee.svg';
import veuveM from './../../../../../assets/images/svg/001-M-veuve.svg';
import homechildren from './../../../../../assets/images/svg/002-homechildren.svg';
import {updateDeathDeclaration} from '../../../../../actions/facilita-api';
import * as loadings from '../../../../../constants/loadings/facilita/deathDeclaration';
import $ from 'jquery';

export const ModalFamily = ({deathDeclaration, userId, isLoading}) => {
    const familyForm = useRef(null);
    const dispatch = useDispatch();

    const familyStatusText = [
        {},
        { 'Male': {label:'Célibataire', logo:celibataireM}, 'Female': {label:'Célibataire', logo:celibataireW} },
        { 'Male': {label:'Marié', logo:unionsM}, 'Female': {label:'Mariée', logo:unionsW} },
        { 'Male': {label:'Divorcé', logo:divorceeM}, 'Female': {label:'Divorcée', logo:divorceeW} },
        { 'Male': {label:'Veuf', logo:veuveM}, 'Female': {label:'Veuve', logo:veuveW} },
        { 'Male': {label:'Union libre', logo:unionsM}, 'Female': {label:'Union libre', logo:unionsW} },
        { 'Male': {label:'Pacsé', logo:unionsM}, 'Female': {label:'Pacsée', logo:unionsW} }
    ];
    const genderKey = (deathDeclaration.gender === 'Female' || deathDeclaration.gender === 1) ? 'Female' : 'Male';
    const [wasValidated, setWasValidated] = useState(false);
    const [family, setFamily] = useState(undefined);

    const [civilData, setCivilData] = useState({
		civilStatus: deathDeclaration.civilStatus,
		houseHoldCount: deathDeclaration.houseHoldCount,
        hasChildren: deathDeclaration.hasChildren
	});


    return (
        <div className="modal fade px-0" id="familyModal" aria-labelledby="familyModalLabel" aria-hidden="true">
            <div className="modal-dialog px-2 container-screen">
                <div className="modal-content">
                    <div className="modal-header" data-dismiss="modal" aria-label="Close">
                        <div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <h1 className="sr-only visually-hidden">Information deceased</h1>
                            <div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="familyModalLabel">modifier les champs</div>
                        </div>
                    </div>
                    <div className="modal-body py-0">
                        <p className="o-60">Modifier les informations qui ne sont pas à jour.</p>
                        <form className="block" ref={familyForm}>
                            <div className="block mb-3 mb-lg-sm">
                                <h5 className="h6 font-weight-bolder text-uppercase">SITUATION FAMILIALE</h5>
                                <div className="form-row">
                                    <div className="form-group col col-lg-4 col-xl" onClick={() => { setCivilData({...civilData, civilStatus: 1}) }}>
                                        <div className={"card card-body text-center picker-card" + (civilData.civilStatus === 1 ? ' active' : '')}>
                                            <img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[1][genderKey].logo} alt="Célibataire" />
                                            <h2 className="h6 font-weight-bolder my-auto">{familyStatusText[1][genderKey].label}</h2>
                                        </div>
                                    </div>
                                    <div className="form-group col col-lg-4 col-xl" onClick={() => { setCivilData({...civilData, civilStatus: 2}) }}>
                                        <div className={"card card-body text-center picker-card" + (civilData.civilStatus === 2 ? ' active' : '')}>
                                            <img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[2][genderKey].logo} alt={familyStatusText[2][genderKey].label} />
                                            <h2 className="h6 font-weight-bolder my-auto" >{familyStatusText[2][genderKey].label}</h2>
                                        </div>
                                    </div>
                                    <div className="form-group col col-lg-4 col-xl" onClick={() => { setCivilData({...civilData, civilStatus: 3}) }}>
                                        <div className={"card card-body text-center picker-card" + (civilData.civilStatus === 3 ? ' active' : '')}>
                                            <img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[3][genderKey].logo} alt={familyStatusText[3][genderKey].label} />
                                            <h2 className="h6 font-weight-bolder my-auto">{familyStatusText[3][genderKey].label}</h2>
                                        </div>
                                    </div>
                                    <div className="form-group col col-lg-4 col-xl" onClick={() => { setCivilData({...civilData, civilStatus: 4}) }}>
                                        <div className={"card card-body text-center picker-card" + (civilData.civilStatus === 4 ? ' active' : '')}>
                                            <img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[4][genderKey].logo} alt={familyStatusText[4][genderKey].label} />
                                            <h2 className="h6 font-weight-bolder my-auto">{familyStatusText[4][genderKey].label}</h2>
                                        </div>
                                    </div>
                                    <div className="form-group col col-lg-4 col-xl" onClick={() => { setCivilData({...civilData, civilStatus: 5}) }}>
                                        <div className={"card card-body text-center picker-card" + (civilData.civilStatus === 5 ? ' active' : '')}>
                                            <img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[5][genderKey].logo} alt={familyStatusText[5][genderKey].label} />
                                            <h2 className="h6 font-weight-bolder my-auto">{familyStatusText[5][genderKey].label}</h2>
                                        </div>
                                    </div>
                                    <div className="form-group col col-lg-4 col-xl" onClick={() => { setCivilData({...civilData, civilStatus: 6}) }}>
                                        <div className={"card card-body text-center picker-card" + (civilData.civilStatus === 6 ? ' active' : '')}>
                                            <img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[6][genderKey].logo} alt={familyStatusText[6][genderKey].label} />
                                            <h2 className="h6 font-weight-bolder my-auto">{familyStatusText[6][genderKey].label}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className={"invalid-feedback alert-danger alert" + (family === undefined && wasValidated === true ? ' d-block' : '')}>
                                    Veuillez choisir une option
                                </div>
                            </div>
                            <div className="row g-3">
                                <div className="form-group mb-2 col-12 col-md-8 col-lg-6">
                                    <h5 className="h6 font-weight-bolder text-uppercase">ENFANTS</h5>
                                    <div className="form-row h-100">
                                        <div className="form-group col" onClick={() => { setCivilData({ ...civilData, hasChildren: true }) }}>
                                            <div className={"card card-body text-center picker-card" + (civilData.hasChildren ? ' active' : '')}>
                                                <img className="img-fluid mx-auto my-3 mb-2 h-6" src={children} alt="oui" />
                                                <h2 className="h6 font-weight-bolder my-auto">J'ai des enfants</h2>
                                            </div>
                                        </div>
                                        <div className="form-group col" onClick={() => { setCivilData({ ...civilData, hasChildren: false }) }}>
                                            <div className={"card card-body text-center picker-card" + (!civilData.hasChildren ? ' active' : '')}>
                                                <img className="img-fluid mx-auto my-3 mb-2 h-6" src={noChildren} alt="none" />
                                                <h2 className="h6 font-weight-bolder my-auto" >Je n'ai pas d'enfants</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-0 col-12 col-md col-lg-3 col-xl">
                                    <h5 className="h6 font-weight-bolder text-uppercase">Autres</h5>
                                    <div className="row gx-2 mb-12">
                                        <div className="col-6 col-md col-xl-6">
                                            <div className={"card card-body text-center picker-card" + ((civilData.houseHoldCount>0) ? ' active' : '')}>
                                                <img className="img-fluid mx-auto mb-3 mt-2 h-6" src={homechildren} alt="autre" />
                                                {/* <h2 className="h6 font-weight-bolder my-auto">Autre Personne <br />Dans Le Foyer</h2> */}
                                                <label className="h6 font-weight-bolder my-auto" htmlFor="otherPeople">Autre Personne Dans Le Foyer</label>
                                                <input required type="number" className="form-control text-center mx-auto pl-3 pr-1 mt-2 bg-light border-none" id="otherPeople" placeholder="0" value={civilData.houseHoldCount} onChange={(event) => {
                                                    setCivilData({ ...civilData, houseHoldCount: event.target.value })
                                                }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-light mr-2" data-dismiss="modal">Fermer</button>
                        {
							isLoading.includes(loadings.UPDATING_DECLARATION) ? 
								<button type="button" className="btn btn-info loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder</button>

							:
								<button type="button" className="btn btn-info" onClick={(e) => {
									e.preventDefault();
									familyForm.current.classList.add('was-validated');
									if (familyForm.current.checkValidity()){
										dispatch(updateDeathDeclaration(userId, {
											...deathDeclaration,
											civilStatus: civilData.civilStatus,
											houseHoldCount: civilData.houseHoldCount,
                                            hasChildren: civilData.hasChildren
										})).then(() => $('.modal').modal("hide"));
									}
								}}>Sauvegarder</button>
						}
                    </div>
                </div>
            </div>
        </div>
    )
}